import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ContainerButton from '../../../components/button/ContainerButton';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import StateComponents from '../../../components/state-component/StateComponents';
import { Box, Grid, Radio, Tab, Tabs, Typography } from '@mui/material';
import InputTextField from '../../../components/input/inputTextField';
import AddImage from "../../../assets/icons/add_image.png";
import { handleTypingNumber } from '../../../utils/app.utils';
import { routeName } from '../../../routes/routeName';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { alertActive, alertError, alertSuccess, swalError } from '../../../components/alert/swal';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { VisaRequestFrontApi } from '../../../api/visa-request-front/visa-request-front.api';
import { RequestFormCreate } from '../visa-request/visa-request-create';
import { VisaRequestAdminApi } from '../../../api/visa-request-admin/visa-request-admin.api';
import ModalCustom from '../../../components/modal/ModalCustom';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
import { VisaFormApi } from '../../../api/visa-form/visa-form.api';
import AddBoxIcon from '@mui/icons-material/AddBox';
import moment from 'moment';
import { RegisterPayment } from '../visa-request/visa-request-detail';
import { timeToView } from '../../../utils/date.utils';
import { renderStatus, STATUS_VISA } from './enum/request-form.enum';
import StatusCustom from '../../../components/status/statusCustom';
import { VisaSatisfactionApi } from '../../../api/visa-satisfaction/visa-satisfaction.api';

export default function ManageRequestDetail(props: any) {
    const { view } = props
    const { t } = useTranslation();
    const { id } = useParams()
    const dispatch = useDispatch();
    const uploadRefs = useRef<HTMLInputElement[]>([]);

    const navigate = useNavigate()
    const [pathUrl, setPathUrl] = useState<any>(null);
    const [student, setStudent] = useState<any>({})
    const [showModal, setShowModal] = useState<number>();
    const [remark, setRemark] = useState<string>("");
    const [showModalGuestion, setShowModalGuestion] = useState<string>("");
    const [form, setForm] = useState<any>({
        visa_form_name: ''
    });
    // const [refer_number, set_refer_number] = useState<string>(""); 4
    const [formAccepting, setFormAccepting] = useState<any>({})

    const [visaFormDocuments, setVisaFormDocuments] = useState<any[]>([]);

    const [files, setFiles] = useState<any[]>([]);
    const [filesRemove, setFilesRemove] = useState<any[]>([]);
    const [value, setValue] = React.useState(0);
    const [visaSatisfaction, setVisaSatisfaction] = useState<any[]>([]);
    const [visaSatisfactionDetail, setVisaSatisfactionDetail] = useState<any>();
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    const handleCloseModal = () => {
        setShowModal(0);
        setFormAccepting({})
    }

    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results.REACT_APP_BASE_API_PUBLIC);
        };
        init();
    }, []);
    const findById = async () => {

        await VisaRequestAdminApi.findById(id).then((res) => {
            if (res.status < 300) {
                setForm(res.data?.data);
                setStudent(res.data?.data);
                setVisaFormDocuments(res.data?.data?.visa_form_document)
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const getVisaSatisfactionDetail = async () => {

        await VisaSatisfactionApi.visarequest(id).then((res) => {
            if (res.status < 300) {
                // setForm(res.data?.data);
                setVisaSatisfactionDetail(res.data?.data)
                if (res.data?.data) {
                    setRemark(res.data?.data?.remark)
                    setVisaSatisfaction(res.data?.data?.visa_satisfaction_details)

                } else {
                    // getVisaSatisfaction()
                }
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        findById()
        getVisaSatisfactionDetail()
    }, [])


    const handleAccepting = async () => {

        dispatch(setLoading());

        await VisaRequestAdminApi.accepting(Number(id))
            .then(async (res) => {
                if (res.status < 300) {

                    //         navigate(routeName.admission.AdmissionFormUpdte?.replace(':id', res.data.data?.id_admission_student))
                    // alertSuccess("Save Draft", "succeed")
                    if (files?.length > 0) {
                        const formData = new FormData();

                        files.forEach((file) => {
                            formData.append("files", file?.file);
                            formData.append("id_visa_form_document", file.id_visa_form_document);
                            formData.append("id_visa_step", file.id_visa_step);
                            formData.append("document_name", file.document_name);
                            formData.append("document_type", file.document_type);
                        });

                        await VisaRequestFrontApi.file(id, formData)
                            .then((resp) => {
                                if (resp.status < 300) {
                                    alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                                        state: {
                                            id_visa_step: form?.current_step?.id_visa_step
                                        }
                                    }));
                                }
                            })
                    } else {
                        alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                            state: {
                                id_visa_step: form?.current_step?.id_visa_step
                            }
                        }));
                    }

                }
            })
            .catch((err) => {
                console.log(err);
                alertError("Save Draft", err?.response?.data?.message || "Error");
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
        // }

    }
    const handleSecretariatOfficer = async () => {

        const body = {
            "refer_number": formAccepting?.refer_number
        }
        // console.log(files);
        dispatch(setLoading());

        await VisaRequestAdminApi.secretariatOfficer(Number(id), body)
            .then(async (res) => {
                if (res.status < 300) {

                    //         navigate(routeName.admission.AdmissionFormUpdte?.replace(':id', res.data.data?.id_admission_student))
                    // alertSuccess("Save Draft", "succeed")
                    if (files?.length > 0) {
                        const formData = new FormData();

                        files.forEach((file) => {
                            formData.append("files", file?.file);
                            formData.append("id_visa_form_document", file?.id_visa_form_document);
                            formData.append("id_visa_step", file?.id_visa_step);
                            formData.append("document_name", file?.document_name);
                            formData.append("document_type", file?.document_type);
                        });

                        await VisaRequestFrontApi.file(id, formData)
                            .then((resp) => {
                                if (resp.status < 300) {
                                    alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                                        state: {
                                            id_visa_step: form?.current_step?.id_visa_step
                                        }
                                    }));
                                }
                            })
                    } else {
                        alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                            state: {
                                id_visa_step: form?.current_step?.id_visa_step
                            }
                        }));
                    }

                }
            })
            .catch((err) => {
                console.log(err);
                alertError("Save Draft", err?.response?.data?.message || "Error");
            })
            .finally(() => {
                dispatch(unsetLoading());
            });

    }
    const handleDormitoryStaff = async () => {

        const body = formAccepting
        dispatch(setLoading());

        await VisaRequestAdminApi.dormitoryStaff(Number(id), body)
            .then(async (res) => {
                if (res.status < 300) {

                    //         navigate(routeName.admission.AdmissionFormUpdte?.replace(':id', res.data.data?.id_admission_student))
                    // alertSuccess("Save Draft", "succeed")
                    if (files?.length > 0) {
                        const formData = new FormData();

                        files.forEach((file) => {
                            formData.append("files", file?.file);
                            formData.append("id_visa_form_document", file?.id_visa_form_document);
                            formData.append("id_visa_step", file?.id_visa_step);
                            formData.append("document_name", file?.document_name);
                            formData.append("document_type", file?.document_type);
                        });

                        await VisaRequestFrontApi.file(id, formData)
                            .then((resp) => {
                                if (resp.status < 300) {
                                    alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                                        state: {
                                            id_visa_step: form?.current_step?.id_visa_step
                                        }
                                    }));
                                }
                            })
                    } else {
                        alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                            state: {
                                id_visa_step: form?.current_step?.id_visa_step
                            }
                        }));
                    }

                }
            })
            .catch((err) => {
                console.log(err);
                alertError("Save Draft", err?.response?.data?.message || "Error");
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
        // }

    }
    const handleDivisionOfAffairsOfficer = async () => {

        dispatch(setLoading());

        await VisaRequestAdminApi.divisionOfAffairsOfficer(Number(id))
            .then(async (res) => {
                if (res.status < 300) {

                    //         navigate(routeName.admission.AdmissionFormUpdte?.replace(':id', res.data.data?.id_admission_student))
                    // alertSuccess("Save Draft", "succeed")
                    if (files?.length > 0) {
                        const formData = new FormData();

                        files.forEach((file) => {
                            formData.append("files", file?.file);
                            formData.append("id_visa_form_document", file?.id_visa_form_document);
                            formData.append("id_visa_step", file?.id_visa_step);
                            formData.append("document_name", file?.document_name);
                            formData.append("document_type", file?.document_type);
                        });

                        await VisaRequestFrontApi.file(id, formData)
                            .then((resp) => {
                                if (resp.status < 300) {
                                    alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                                        state: {
                                            id_visa_step: form?.current_step?.id_visa_step
                                        }
                                    }));
                                }
                            })
                    } else {
                        alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                            state: {
                                id_visa_step: form?.current_step?.id_visa_step
                            }
                        }));
                    }

                }
            })
            .catch((err) => {
                console.log(err);
                alertError("Save Draft", err?.response?.data?.message || "Error");
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
        // }

    }
    const handleForeignAffairsDivisionOfficer = async () => {

        dispatch(setLoading());

        await VisaRequestAdminApi.foreignAffairsDivisionOfficer(Number(id))
            .then(async (res) => {
                if (res.status < 300) {

                    //         navigate(routeName.admission.AdmissionFormUpdte?.replace(':id', res.data.data?.id_admission_student))
                    // alertSuccess("Save Draft", "succeed")
                    if (files?.length > 0) {
                        const formData = new FormData();

                        files.forEach((file) => {
                            formData.append("files", file?.file);
                            formData.append("id_visa_form_document", file?.id_visa_form_document);
                            formData.append("id_visa_step", file?.id_visa_step);
                            formData.append("document_name", file?.document_name);
                            formData.append("document_type", file?.document_type);
                        });

                        await VisaRequestFrontApi.file(id, formData)
                            .then((resp) => {
                                if (resp.status < 300) {
                                    alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                                        state: {
                                            id_visa_step: form?.current_step?.id_visa_step
                                        }
                                    }));
                                }
                            })
                    } else {
                        alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                            state: {
                                id_visa_step: form?.current_step?.id_visa_step
                            }
                        }));
                    }

                }
            })
            .catch((err) => {
                console.log(err);
                alertError("Save Draft", err?.response?.data?.message || "Error");
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
        // }

    }
    const handleCourseDirector = async () => {

        dispatch(setLoading());

        await VisaRequestAdminApi.courseDirector(Number(id))
            .then(async (res) => {
                if (res.status < 300) {

                    //         navigate(routeName.admission.AdmissionFormUpdte?.replace(':id', res.data.data?.id_admission_student))
                    // alertSuccess("Save Draft", "succeed")
                    if (files?.length > 0) {
                        const formData = new FormData();

                        files.forEach((file) => {
                            formData.append("files", file?.file);
                            formData.append("id_visa_form_document", file?.id_visa_form_document);
                            formData.append("id_visa_step", file?.id_visa_step);
                            formData.append("document_name", file?.document_name);
                            formData.append("document_type", file?.document_type);
                        });

                        await VisaRequestFrontApi.file(id, formData)
                            .then((resp) => {
                                if (resp.status < 300) {
                                    alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                                        state: {
                                            id_visa_step: form?.current_step?.id_visa_step
                                        }
                                    }));
                                }
                            })
                    } else {
                        alertSuccess(t("LIST_APPLICANTS_SAVE"), t("LIST_APPLICANTS_SAVE_SUCCESS"), undefined, () => navigate(routeName.request_form.manage_request, {
                            state: {
                                id_visa_step: form?.current_step?.id_visa_step
                            }
                        }));
                    }

                }
            })
            .catch((err) => {
                console.log(err);
                alertError("Save Draft", err?.response?.data?.message || "Error");
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
        // }

    }
    const handleReceive = async () => {

        const body: any = {
            keyword: undefined,
            start_date: undefined,
            end_date: undefined,
            is_check_all: false,
            id_visa_step: form?.current_step?.id_visa_step,
            include_id_visa_requests: [Number(id)],
            exclude_id_visa_requests: []
        }
        dispatch(setLoading());
        await VisaRequestAdminApi.receive(body)
            .then((res) => {
                if (res.status < 300) {


                    alertSuccess(
                        "รับคำร้อง",
                        "รับคำร้อง เรียบร้อยแล้ว",
                        undefined,
                        () => {
                            // navigate(-1);
                            // setStep(step + 1)
                            findById()
                        }
                    );
                }
            })
            .catch((error) => {
                console.log(error);
                swalError(error?.response?.data?.th || error?.response?.data?.message || "เกิดข้อผิดพลาด");

            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    const handleReject = async () => {

        const body: any = formAccepting
        dispatch(setLoading());
        await VisaRequestAdminApi.reject(Number(id), body)
            .then((res) => {
                if (res.status < 300) {


                    alertSuccess(
                        "ปฏิเสธคำร้อง",
                        "ปฏิเสธคำร้อง เรียบร้อยแล้ว",
                        undefined,
                        () => {
                            // navigate(-1);
                            // setStep(step + 1)
                            navigate(routeName.request_form.manage_request, {
                                state: {
                                    id_visa_step: form?.current_step?.id_visa_step
                                }
                            })
                        }
                    );
                }
            })
            .catch((error) => {
                console.log(error);
                swalError(error?.response?.data?.th || error?.response?.data?.message || "เกิดข้อผิดพลาด");

            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    const handleReview = async () => {

        const body: any = formAccepting
        dispatch(setLoading());
        await VisaRequestAdminApi.review(Number(id), body)
            .then((res) => {
                if (res.status < 300) {


                    alertSuccess(
                        "ส่งทบทวน",
                        "ส่งทบทวน เรียบร้อยแล้ว",
                        undefined,
                        () => {
                            // navigate(-1);
                            // setStep(step + 1)
                            navigate(routeName.request_form.manage_request, {
                                state: {
                                    id_visa_step: form?.current_step?.id_visa_step
                                }
                            })
                        }
                    );
                }
            })
            .catch((error) => {
                console.log(error);
                swalError(error?.response?.data?.th || error?.response?.data?.message || "เกิดข้อผิดพลาด");

            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    const handleTeacher = async () => {

        const body: any = formAccepting
        dispatch(setLoading());
        await VisaRequestAdminApi.teacher(Number(id), body)
            .then((res) => {
                if (res.status < 300) {


                    alertSuccess(
                        "อนุมัติคำร้อง",
                        "อนุมัติคำร้อง เรียบร้อยแล้ว",
                        undefined,
                        () => {
                            // navigate(-1);
                            // setStep(step + 1)
                            navigate(routeName.request_form.manage_request, {
                                state: {
                                    id_visa_step: form?.current_step?.id_visa_step
                                }
                            })
                        }
                    );
                }
            })
            .catch((error) => {
                console.log(error);
                swalError(error?.response?.data?.th || error?.response?.data?.message || "เกิดข้อผิดพลาด");

            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    const handleRegistrar = async () => {

        const body: any = formAccepting
        dispatch(setLoading());
        await VisaRequestAdminApi.registrar(Number(id), body)
            .then(async (res) => {
                if (res.status < 300) {
                    if (files?.length > 0) {
                        const formData = new FormData();

                        files.forEach((file) => {
                            formData.append("files", file?.file);
                            formData.append("id_visa_form_document", file?.id_visa_form_document);
                            formData.append("id_visa_step", file?.id_visa_step);
                            formData.append("document_name", file?.document_name);
                            formData.append("document_type", file?.document_type);
                        });

                        await VisaRequestFrontApi.file(id, formData)
                            .then((resp) => {
                                if (resp.status < 300) {
                                    alertSuccess(t("ดำเนินการปรับสถานะลาออก"), t("ดำเนินการปรับสถานะลาออก เรียบร้อยแล้ว"), undefined, () => navigate(routeName.request_form.manage_request, {
                                        state: {
                                            id_visa_step: form?.current_step?.id_visa_step
                                        }
                                    }));
                                }
                            })
                    } else {
                        alertSuccess(t(form?.visa_form?.id_visa_type === 18 ? 'อนุมัติคำร้อง' : "ดำเนินการปรับสถานะลาออก"), t(form?.visa_form?.id_visa_type === 18 ? 'อนุมัติคำร้อง เรียบร้อยแล้ว' : "ดำเนินการปรับสถานะลาออก เรียบร้อยแล้ว"), undefined, () => navigate(routeName.request_form.manage_request, {
                            state: {
                                id_visa_step: form?.current_step?.id_visa_step
                            }
                        }));
                    }

                }
            })
            .catch((error) => {
                console.log(error);
                swalError(error?.response?.data?.th || error?.response?.data?.message || "เกิดข้อผิดพลาด");

            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    const handleExam = async () => {

        const body: any = {
            visa_examination_name: formAccepting?.visa_examination_name,
            visa_examination_start_date: `${formAccepting?.visa_examination_start_date}T${formAccepting?.visa_examination_start_time}`,
            visa_examination_end_date: `${formAccepting?.visa_examination_end_date}T${formAccepting?.visa_examination_start_time}`
        }
        dispatch(setLoading());
        await VisaRequestAdminApi.exam(Number(id), body)
            .then(async (res) => {
                if (res.status < 300) {
                    if (files?.length > 0) {
                        const formData = new FormData();


                        files.forEach((file) => {
                            formData.append("files", file?.file);
                            // formData.append("id_visa_form_document", file?.id_visa_form_document);
                            // formData.append("id_visa_step", file?.id_visa_step);
                            // formData.append("document_name", file?.document_name);
                            // formData.append("document_type", file?.document_type);
                        });

                        await VisaRequestAdminApi.examFile(Number(id), res.data.data.id_visa_examination, formData)
                            .then((resp) => {
                                if (resp.status < 300) {
                                    alertSuccess(
                                        "อนุมัติคำร้อง",
                                        "อนุมัติคำร้อง เรียบร้อยแล้ว",
                                        undefined,
                                        () => {
                                            // navigate(-1);
                                            // setStep(step + 1)
                                            navigate(routeName.request_form.manage_request, {
                                                state: {
                                                    id_visa_step: form?.current_step?.id_visa_step
                                                }
                                            })
                                        }
                                    );
                                }
                            })
                    } else {
                        alertSuccess(
                            "อนุมัติคำร้อง",
                            "อนุมัติคำร้อง เรียบร้อยแล้ว",
                            undefined,
                            () => {
                                // navigate(-1);
                                // setStep(step + 1)
                                navigate(routeName.request_form.manage_request, {
                                    state: {
                                        id_visa_step: form?.current_step?.id_visa_step
                                    }
                                })
                            }
                        );
                    }

                }
            })
            .catch((error) => {
                console.log(error);
                swalError(error?.response?.data?.th || error?.response?.data?.message || "เกิดข้อผิดพลาด");

            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("รายละเอียดคำร้อง")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("ระบบคำร้อง"),
                                disabled_match: true,
                                pathName: routeName.request_form.manage_request_forms
                            },
                            {
                                key: "complaintSubmit",
                                name: t("จัดการข้อมูลคำร้อง"),
                                pathName: routeName.request_form.manage_request_forms
                            },
                            {
                                key: "complaintSubmit",
                                name: t("รายละเอียดคำร้อง"),
                                pathName: routeName.request_form.manage_request_form_add
                            },
                        ]}
                    />
                }
                buttonContent={

                    <ContainerButton
                        // sxContainer={{ my: 3 }}
                        justifyContent='flex-end'
                        buttonData={[
                            {
                                seq: 1,
                                buttonProps: {
                                    onClick: () => { navigate(-1) },
                                },
                                key: "CANCEL",
                                label: t("LIST_APPLICANTS_BACK"),
                                type: "CANCEL"
                            },
                            {
                                seq: 2,
                                hidden: view || (form?.visa_form?.id_visa_type === 17 && form?.current_step?.id_visa_step === 7),
                                buttonProps: {
                                    onClick: () => {
                                        //   setShowModal('REJECT')
                                        setShowModal(98)
                                    }
                                },
                                key: "REJECT",
                                label: t("ปฏิเสธ"),
                                type: 'REJECT'
                            },
                            {
                                seq: 3,
                                hidden: view || form?.status_visa !== 'WAITING_RECEIVE_REQUEST',
                                buttonProps: {
                                    onClick: () => {
                                        //   setShowModal('REJECT')
                                        handleReceive()
                                    }
                                },
                                key: "APPROVE2",
                                label: t("รับเรื่อง"),
                                type: 'APPROVE2'
                            },
                            {
                                seq: 4,
                                hidden: view || !(form?.visa_form?.id_visa_type === 17 && form?.current_step?.id_visa_step === 7),
                                buttonProps: {
                                    onClick: () => {
                                        //   setShowModal('REJECT')
                                        setShowModal(form?.current_step?.id_visa_step)
                                    }
                                },
                                key: "REJECT",
                                label: t("ดำเนินการปรับสถานะ"),
                                type: 'REJECT'
                            },

                            {
                                seq: 1.5,
                                hidden: view || form?.status_visa === 'WAITING_RECEIVE_REQUEST' || (form?.visa_form?.id_visa_type === 17 && form?.current_step?.id_visa_step === 7),
                                buttonProps: {
                                    onClick: () => {
                                        // alertActive(t("LIST_APPLICANTS_APPROVED"), t("LIST_APPLICANTS_CONFIRM_DECISION"), undefined, undefined, async () => {
                                        // })
                                        // handleSubmit()
                                        setShowModal(99)

                                    }
                                },
                                key: "RETURN",
                                label: t("ส่งทบทวน"),
                                type: 'RETURN'
                            },
                            {
                                seq: 3,
                                hidden: view || form?.status_visa === 'WAITING_RECEIVE_REQUEST' || (form?.visa_form?.id_visa_type === 17 && form?.current_step?.id_visa_step === 7),
                                buttonProps: {
                                    onClick: () => {
                                        if (form?.visa_form?.id_visa_type === 17) {
                                            if (form?.current_step?.id_visa_step === 2) {
                                                alertActive(t("อนุมัติคำร้อง"), t("ต้องการอนุมัติคำร้อง หรือไม่"), undefined, undefined, async () => {
                                                    handleAccepting()
                                                })
                                            } else if (form?.current_step?.id_visa_step === 9) {
                                                alertActive(t("อนุมัติคำร้อง"), t("ต้องการอนุมัติคำร้อง หรือไม่"), undefined, undefined, async () => {
                                                    handleCourseDirector()
                                                })
                                            } else {
                                                setShowModal(form?.current_step?.id_visa_step)
                                            }
                                        } else if (form?.visa_form?.id_visa_type === 18) {
                                            if (form?.current_step?.id_visa_step === 2) {
                                                if (form?.status_visa === 'WAITING_PAYMENT_VERIFICATION') {
                                                    setShowModal(form?.current_step?.id_visa_step)

                                                } else {
                                                    alertActive(t("อนุมัติคำร้อง"), t("ต้องการอนุมัติคำร้อง หรือไม่"), undefined, undefined, async () => {
                                                        handleAccepting()
                                                    })
                                                }

                                            } else if (form?.current_step?.id_visa_step === 7) {
                                                alertActive(t("อนุมัติคำร้อง"), t("ต้องการอนุมัติคำร้อง หรือไม่"), undefined, undefined, async () => {
                                                    handleRegistrar()
                                                })
                                            } else {
                                                setShowModal(form?.current_step?.id_visa_step)
                                            }
                                        } else {
                                            setShowModal(form?.current_step?.id_visa_step)
                                        }
                                        // alertActive(t("LIST_APPLICANTS_APPROVED"), t("LIST_APPLICANTS_CONFIRM_DECISION"), undefined, undefined, async () => {
                                        //     handleAccepting()
                                        // })
                                        // handleSubmit()
                                    }
                                },
                                key: "APPROVE",
                                label: t("อนุมัติ"),
                                type: 'APPROVE'
                            },
                            {
                                seq: 5,
                                hidden: ![STATUS_VISA.COMPLETE].includes(form?.status_visa) || !visaSatisfactionDetail,
                                buttonProps: {
                                    onClick: () => {
                                        setShowModalGuestion('ADD')
                                    }
                                },
                                key: "SAVE",
                                label: t("ประเมินความพึ่งพอใจ"),
                                type: 'APPROVE',
                            },
                        ]}
                    />
                }
                content={

                    <>
                        <Box sx={{ maxWidth: '300px', marginBottom: "10px" }}>
                            <StatusCustom
                                disableMaxWidth
                                text={renderStatus(form?.status_visa)}
                                type={renderStatus(form?.status_visa)}
                            />
                        </Box>
                        {![16, 17, 18].includes(form?.visa_form?.id_visa_type) && (form?.current_id_visa_step === 2 ? ![STATUS_VISA.WAITING_RECEIVE_REQUEST, STATUS_VISA.RECEIVE_REQUEST].includes(form?.status_visa) : form?.visa_form?.id_visa_type === 18 ? false : true) && <Tabs
                            sx={{
                                marginBottom: '20px', borderBottom: "2px solid #F2F4F7", '& .MuiTab-root': {
                                    background: '#F2F4F7'
                                }, '& .Mui-selected': {
                                    background: "#4A4A4A",
                                    color: "#FFFFFF !important"
                                }, '& .MuiTabs-indicator': {
                                    display: 'none'
                                }
                            }}
                            value={value}
                            onChange={handleChange}
                            // indicator="none"
                            aria-label="secondary tabs example"
                        >
                            {form?.visa_form?.visa_type?.visa_type_steps?.sort((a: any, b: any) => a?.seq - b?.seq)?.map((item: any) => {
                                return (
                                    form?.status_visa === STATUS_VISA.COMPLETE ? form?.current_id_visa_step >= item?.id_visa_step && <Tab label={item?.visa_step?.visa_step} /> : form?.current_id_visa_step > item?.id_visa_step && <Tab label={item?.visa_step?.visa_step} />
                                )
                            })}

                            {/* {form?.current_step?.id_visa_step > 2 && (form?.visa_form?.id_visa_type === 1 || form?.visa_form?.id_visa_type === 2) && <Tab label="ข้อมูลจากผู้ประสานงานฯ" />}
                            {form?.current_step?.id_visa_step > 3 && (form?.visa_form?.id_visa_type === 1 || form?.visa_form?.id_visa_type === 2) && <Tab label="ข้อมูลจากเจ้าหน้าที่สารบรรณ" />}
                            {form?.current_step?.id_visa_step > 4 && (form?.visa_form?.id_visa_type === 1) && <Tab label="ข้อมูลจากเจ้าหน้าที่หอพัก" />}
                            {form?.current_step?.id_visa_step > 5 && (form?.visa_form?.id_visa_type === 1) && <Tab label="ข้อมูลจากเจ้าหน้าที่กองกิจการนิสิต" />}
                            {form?.current_step?.id_visa_step >= 6 && (form?.visa_form?.id_visa_type === 1) && <Tab label="ข้อมูลจากเจ้าหน้าที่กองวิเทศน์" />} */}

                        </Tabs>}
                        {[16, 17, 18].includes(form?.visa_form?.id_visa_type) && ![STATUS_VISA.WAITING_RECEIVE_REQUEST, STATUS_VISA.RECEIVE_REQUEST].includes(form?.status_visa) && <>
                            <Tabs
                                sx={{
                                    marginBottom: '20px', borderBottom: "2px solid #F2F4F7", '& .MuiTab-root': {
                                        background: '#F2F4F7'
                                    }, '& .Mui-selected': {
                                        background: "#4A4A4A",
                                        color: "#FFFFFF !important"
                                    }, '& .MuiTabs-indicator': {
                                        display: 'none'
                                    }
                                }}
                                value={value}
                                onChange={handleChange}
                                // indicator="none"
                                aria-label="secondary tabs example"
                            >
                                <Tab value={0} label="รายละเอียด" />
                                {[18].includes(form?.visa_form?.id_visa_type) && <Tab value={98} label="ข้อมูลการชำระเงิน" />}
                                {[STATUS_VISA.COMPLETE].includes(form?.status_visa) && <Tab value={99} label="สรุปผล" />}
                            </Tabs>

                        </>}

                        {value === 0 && <RequestFormCreate view={true} form={form} setForm={setForm} student={student} setStudent={setStudent} getVisaForm={findById} visaForm={form?.visa_form} visaFormDocuments={visaFormDocuments} setVisaFormDocuments={setVisaFormDocuments} />
                        }
                        {value === 1 &&
                            <Box sx={{
                                border: '1px solid #DDE1EB',
                                borderRadius: '18px', overflow: 'hidden'
                            }}>
                                <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
                                </Box>
                                <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 2)?.map((x: any) => {
                                        return (
                                            <>
                                                {x?.visa_request_documents?.map((y: any) => {
                                                    return (
                                                        <Box sx={{
                                                            border: '1px solid #DDE1EB',
                                                            borderRadius: '18px', overflow: 'hidden',
                                                            padding: '10px 15px'
                                                        }}>
                                                            <Typography sx={{ fontSize: '18px', fontWeight: '600' }}>{x?.document_name}</Typography>
                                                            <Box sx={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: 'space-between' }}>
                                                                <Typography sx={{
                                                                    width: '100%', overflow: "hidden",
                                                                    display: "-webkit-box",
                                                                    WebkitBoxOrient: "vertical",
                                                                    WebkitLineClamp: "1",
                                                                }}>{y?.name || y?.file_name} {formatBytes(y?.size || y?.file_size)}</Typography>
                                                                <OptionsButtonCustom
                                                                    // enableEdit
                                                                    enableView
                                                                    onViewClick={() => { window.open(y?.id_visa_request_document ? `${pathUrl}/${y?.file_path}${y?.file_name}` : URL.createObjectURL(y), '_blank') }}
                                                                // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}

                                                                />
                                                            </Box>
                                                        </Box>
                                                    )
                                                })}
                                            </>

                                        )
                                    })}


                                </Box>
                            </Box>
                        }
                        {value === 2 &&
                            <>
                                {![2, 8, 9, 10]?.includes(form?.visa_form?.id_visa_type) && <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    sxContainer={{ marginBottom: '20px' }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                heading: t("Reference Number"),
                                                value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 3)?.refer_number || '',
                                                onChange: (e) => {
                                                    // setFormAccepting({ ...formAccepting, dormitory_name: e.target.value })
                                                },
                                                disabled: true
                                            }
                                        },

                                    ]} />}
                                <Box sx={{
                                    border: '1px solid #DDE1EB',
                                    borderRadius: '18px', overflow: 'hidden'
                                }}>
                                    <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
                                    </Box>
                                    <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 3)?.map((x: any) => {
                                            return (
                                                <>
                                                    {x?.visa_request_documents?.map((y: any) => {
                                                        return (
                                                            <Box sx={{
                                                                border: '1px solid #DDE1EB',
                                                                borderRadius: '18px', overflow: 'hidden',
                                                                padding: '10px 15px'
                                                            }}>
                                                                <Typography sx={{ fontSize: '18px', fontWeight: '600' }}>{x?.document_name}</Typography>
                                                                <Box sx={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: 'space-between' }}>
                                                                    <Typography sx={{
                                                                        width: '100%', overflow: "hidden",
                                                                        display: "-webkit-box",
                                                                        WebkitBoxOrient: "vertical",
                                                                        WebkitLineClamp: "1",
                                                                    }}>{y?.name || y?.file_name} {formatBytes(y?.size || y?.file_size)}</Typography>
                                                                    <OptionsButtonCustom
                                                                        // enableEdit
                                                                        enableView
                                                                        onViewClick={() => { window.open(y?.id_visa_request_document ? `${pathUrl}/${y?.file_path}${y?.file_name}` : URL.createObjectURL(y), '_blank') }}
                                                                    // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}

                                                                    />
                                                                </Box>
                                                            </Box>
                                                        )
                                                    })}
                                                </>

                                            )
                                        })}

                                    </Box>
                                </Box>
                            </>
                        }
                        {value === 3 &&

                            <>
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    sxContainer={{ marginBottom: '20px' }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                heading: t("Dormitory Name"),
                                                value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 4)?.dormitory_name || '',
                                                onChange: (e) => {
                                                    // setFormAccepting({ ...formAccepting, dormitory_name: e.target.value })
                                                },
                                                disabled: true
                                            }
                                        },

                                        {
                                            seq: 2,
                                            type: "SELECT",
                                            gridProps: {
                                                xs: 12,
                                                md: 4
                                            },
                                            fieldProps: {
                                                labelId: "ss",
                                                heading: "Dormitory Type",
                                                onChange: (e) => {
                                                    // setFormAccepting({ ...formAccepting, dormitory_type: e.target.value })
                                                    // set_id_degree(e.target.value)
                                                },
                                                options: [
                                                    {
                                                        label: 'Male',
                                                        value: "Male",
                                                    },
                                                    {
                                                        label: 'Female',
                                                        value: "Female",
                                                    },
                                                ],
                                                selectId: "",
                                                value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 4)?.dormitory_type || '',
                                                disabled: true
                                            }
                                        },
                                        {
                                            seq: 3,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 4
                                            },
                                            fieldProps: {
                                                heading: t("Room Number"),
                                                value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 4)?.room_number || '',
                                                onChange: (e) => {
                                                    // setFormAccepting({ ...formAccepting, room_number: e.target.value })
                                                },
                                                onkeypress: handleTypingNumber,
                                                disabled: true
                                            }
                                        },
                                        {
                                            seq: 4,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 4
                                            },
                                            fieldProps: {
                                                heading: t("Floor Number"),
                                                value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 4)?.floor_number || '',
                                                onChange: (e) => {
                                                    // setFormAccepting({ ...formAccepting, floor_number: e.target.value })
                                                },
                                                onkeypress: handleTypingNumber,
                                                disabled: true
                                            }
                                        },

                                    ]} />

                                <Box sx={{
                                    border: '1px solid #DDE1EB',
                                    borderRadius: '18px', overflow: 'hidden'
                                }}>
                                    <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
                                    </Box>
                                    <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 4)?.map((x: any) => {
                                            return (
                                                <>
                                                    {x?.visa_request_documents?.map((y: any) => {
                                                        return (
                                                            <Box sx={{
                                                                border: '1px solid #DDE1EB',
                                                                borderRadius: '18px', overflow: 'hidden',
                                                                padding: '10px 15px'
                                                            }}>
                                                                <Typography sx={{ fontSize: '18px', fontWeight: '600' }}>{x?.document_name}</Typography>
                                                                <Box sx={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: 'space-between' }}>
                                                                    <Typography sx={{
                                                                        width: '100%', overflow: "hidden",
                                                                        display: "-webkit-box",
                                                                        WebkitBoxOrient: "vertical",
                                                                        WebkitLineClamp: "1",
                                                                    }}>{y?.name || y?.file_name} {formatBytes(y?.size || y?.file_size)}</Typography>
                                                                    <OptionsButtonCustom
                                                                        // enableEdit
                                                                        enableView
                                                                        onViewClick={() => { window.open(y?.id_visa_request_document ? `${pathUrl}/${y?.file_path}${y?.file_name}` : URL.createObjectURL(y), '_blank') }}
                                                                    // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}

                                                                    />
                                                                </Box>
                                                            </Box>
                                                        )
                                                    })}
                                                </>

                                            )
                                        })}

                                    </Box>
                                </Box>
                            </>
                        }
                        {value === 4 &&
                            <Box sx={{
                                border: '1px solid #DDE1EB',
                                borderRadius: '18px', overflow: 'hidden'
                            }}>
                                <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
                                </Box>
                                <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 5)?.map((x: any) => {
                                        return (
                                            <>
                                                {x?.visa_request_documents?.map((y: any) => {
                                                    return (
                                                        <Box sx={{
                                                            border: '1px solid #DDE1EB',
                                                            borderRadius: '18px', overflow: 'hidden',
                                                            padding: '10px 15px'
                                                        }}>
                                                            <Typography sx={{ fontSize: '18px', fontWeight: '600' }}>{x?.document_name}</Typography>
                                                            <Box sx={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: 'space-between' }}>
                                                                <Typography sx={{
                                                                    width: '100%', overflow: "hidden",
                                                                    display: "-webkit-box",
                                                                    WebkitBoxOrient: "vertical",
                                                                    WebkitLineClamp: "1",
                                                                }}>{y?.name || y?.file_name} {formatBytes(y?.size || y?.file_size)}</Typography>
                                                                <OptionsButtonCustom
                                                                    // enableEdit
                                                                    enableView
                                                                    onViewClick={() => { window.open(y?.id_visa_request_document ? `${pathUrl}/${y?.file_path}${y?.file_name}` : URL.createObjectURL(y), '_blank') }}
                                                                // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}

                                                                />
                                                            </Box>
                                                        </Box>
                                                    )
                                                })}
                                            </>

                                        )
                                    })}

                                </Box>
                            </Box>
                        }
                        {value === 5 &&
                            <Box sx={{
                                border: '1px solid #DDE1EB',
                                borderRadius: '18px', overflow: 'hidden'
                            }}>
                                <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
                                </Box>
                                <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 6)?.map((x: any) => {
                                        return (
                                            <>
                                                {x?.visa_request_documents?.map((y: any) => {
                                                    return (
                                                        <Box sx={{
                                                            border: '1px solid #DDE1EB',
                                                            borderRadius: '18px', overflow: 'hidden',
                                                            padding: '10px 15px'
                                                        }}>
                                                            <Typography sx={{ fontSize: '18px', fontWeight: '600' }}>{x?.document_name}</Typography>
                                                            <Box sx={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: 'space-between' }}>
                                                                <Typography sx={{
                                                                    width: '100%', overflow: "hidden",
                                                                    display: "-webkit-box",
                                                                    WebkitBoxOrient: "vertical",
                                                                    WebkitLineClamp: "1",
                                                                }}>{y?.name || y?.file_name} {formatBytes(y?.size || y?.file_size)}</Typography>
                                                                <OptionsButtonCustom
                                                                    // enableEdit
                                                                    enableView
                                                                    onViewClick={() => { window.open(y?.id_visa_request_document ? `${pathUrl}/${y?.file_path}${y?.file_name}` : URL.createObjectURL(y), '_blank') }}
                                                                // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}

                                                                />
                                                            </Box>
                                                        </Box>
                                                    )
                                                })}
                                            </>

                                        )
                                    })}

                                </Box>
                            </Box>
                        }
                        {value === 98 && <RegisterPayment form={form} setForm={setForm} />}
                        {value === 99 && <>
                            {[18].includes(form?.visa_form?.id_visa_type) && <> <StateComponents
                                otherProps={{ spacing: 2 }}
                                sxContainer={{ marginBottom: '20px' }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            heading: t("สถานที่สอบ"),
                                            value: form?.visa_examination?.visa_examination_name || '',
                                            onChange: (e) => {
                                                // setFormAccepting({ ...formAccepting, visa_examination_name: e.target.value })
                                            },
                                            disabled: true
                                        }
                                    },

                                    {
                                        seq: 2,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 6
                                        },
                                        fieldProps: {
                                            onChange: (e) => {
                                                // setFormAccepting({ ...formAccepting, visa_examination_start_date: moment(e).format('YYYY-MM-DD') })
                                            },
                                            heading: 'วันที่เริ่มต้น',
                                            placeholder: 'วันที่เริ่มต้น',
                                            allowClear: true,
                                            onClear: () => {
                                                setFormAccepting({ ...formAccepting, visa_examination_start_date: '' })
                                            },
                                            value: form?.visa_examination?.visa_examination_start_date,
                                            disabled: true
                                        },
                                    },
                                    {
                                        seq: 4,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 6
                                        },
                                        fieldProps: {
                                            heading: "เวลาเริ่มต้น",
                                            onChange: (e) => {
                                                // setFormAccepting({ ...formAccepting, visa_examination_start_time: e.target.value })
                                            },
                                            value: timeToView(form?.visa_examination?.visa_examination_start_date),
                                            type: 'time',
                                            disabled: true
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 6
                                        },
                                        fieldProps: {
                                            onChange: (e) => {
                                                // setFormAccepting({ ...formAccepting, visa_examination_end_date: moment(e).format('YYYY-MM-DD') })
                                            },
                                            heading: 'วันที่สิ้นสุด',
                                            placeholder: 'วันที่สิ้นสุด',
                                            allowClear: true,
                                            onClear: () => {
                                                setFormAccepting({ ...formAccepting, visa_examination_end_date: '' })
                                            },
                                            value: form?.visa_examination?.visa_examination_end_date,
                                            disabled: true
                                        },
                                    },
                                    {
                                        seq: 5,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 6
                                        },
                                        fieldProps: {
                                            heading: "เวลาสิ้นสุด",
                                            onChange: (e) => {
                                                setFormAccepting({ ...formAccepting, visa_examination_end_time: e.target.value })
                                            },
                                            value: timeToView(form?.visa_examination?.visa_examination_end_date),
                                            type: 'time',
                                            disabled: true
                                        }
                                    },

                                ]} />
                                <Box sx={{
                                    border: '1px solid #DDE1EB',
                                    borderRadius: '18px', overflow: 'hidden'
                                }}>
                                    <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
                                    </Box>
                                    <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        {form?.visa_examination?.visa_examination_files?.map((y: any) => {
                                            return (
                                                <Box sx={{
                                                    border: '1px solid #DDE1EB',
                                                    borderRadius: '18px', overflow: 'hidden',
                                                    padding: '10px 15px'
                                                }}>
                                                    <Typography sx={{ fontSize: '18px', fontWeight: '600' }}>{'ไฟล์แนบ'}</Typography>
                                                    <Box sx={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: 'space-between' }}>
                                                        <Typography sx={{
                                                            width: '100%', overflow: "hidden",
                                                            display: "-webkit-box",
                                                            WebkitBoxOrient: "vertical",
                                                            WebkitLineClamp: "1",
                                                        }}>{y?.name || y?.file_name} {formatBytes(y?.size || y?.file_size)}</Typography>
                                                        <OptionsButtonCustom
                                                            // enableEdit
                                                            enableView
                                                            onViewClick={() => { window.open(y?.id_visa_examination_file ? `${pathUrl}/${y?.file_path}${y?.file_name}` : URL.createObjectURL(y), '_blank') }}
                                                        // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}

                                                        />
                                                    </Box>
                                                </Box>
                                            )
                                        })}


                                    </Box>
                                </Box></>}
                            {[16].includes(form?.visa_form?.id_visa_type) && <>
                                <div className='w-full'>
                                    <StateComponents
                                        otherProps={{ spacing: 2 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    heading: t("หมายเหตุ"),
                                                    value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 8)?.remark || '',
                                                    onChange: (e) => {
                                                        // setFormAccepting({ ...formAccepting, remark: e.target.value })
                                                    },
                                                    minRow: 8,
                                                    multiline: true,
                                                    inputHeight: "auto",
                                                    disabled: true
                                                }
                                            },



                                        ]} />
                                </div></>}
                            {[17].includes(form?.visa_form?.id_visa_type) && <>
                                <div className='w-full'>
                                    <StateComponents
                                        otherProps={{ spacing: 2 }}
                                        sxContainer={{ marginBottom: '20px' }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    heading: t("หมายเหตุ"),
                                                    value: form?.visa_request_details?.find((x: any) => x?.id_visa_step === 7)?.remark || '',
                                                    onChange: (e) => {
                                                        // setFormAccepting({ ...formAccepting, remark: e.target.value })
                                                    },
                                                    minRow: 8,
                                                    multiline: true,
                                                    inputHeight: "auto",
                                                    disabled: true
                                                }
                                            },



                                        ]} />
                                    <Box sx={{
                                        border: '1px solid #DDE1EB',
                                        borderRadius: '18px', overflow: 'hidden'
                                    }}>
                                        <Box sx={{ background: '#4A4A4A', padding: '10px', display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography sx={{ fontWeight: "600", color: '#fff' }}>File</Typography>
                                        </Box>
                                        <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 7)?.map((x: any) => {
                                                return (
                                                    <>
                                                        {x?.visa_request_documents?.map((y: any) => {
                                                            return (
                                                                <Box sx={{
                                                                    border: '1px solid #DDE1EB',
                                                                    borderRadius: '18px', overflow: 'hidden',
                                                                    padding: '10px 15px'
                                                                }}>
                                                                    <Typography sx={{ fontSize: '18px', fontWeight: '600' }}>{x?.document_name}</Typography>
                                                                    <Box sx={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: 'space-between' }}>
                                                                        <Typography sx={{
                                                                            width: '100%', overflow: "hidden",
                                                                            display: "-webkit-box",
                                                                            WebkitBoxOrient: "vertical",
                                                                            WebkitLineClamp: "1",
                                                                        }}>{y?.name || y?.file_name} {formatBytes(y?.size || y?.file_size)}</Typography>
                                                                        <OptionsButtonCustom
                                                                            // enableEdit
                                                                            enableView
                                                                            onViewClick={() => { window.open(y?.id_visa_request_document ? `${pathUrl}/${y?.file_path}${y?.file_name}` : URL.createObjectURL(y), '_blank') }}
                                                                        // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}

                                                                        />
                                                                    </Box>
                                                                </Box>
                                                            )
                                                        })}
                                                    </>

                                                )
                                            })}

                                        </Box>
                                    </Box>
                                </div></>}
                        </>}

                    </>
                }
            />
            {/* {true && ( */}
            {showModal === 2 && (
                <ModalCustom
                    open
                    title={'อนุมัติคำร้อง'}
                    subTitle={t("กรุณาระบุรายละเอียด")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: form?.visa_form?.id_visa_type === 18 ? false : files?.length === 0,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { form?.visa_form?.id_visa_type === 18 ? handleExam() : handleAccepting() }
                    }}
                    component={
                        <div className='w-full' style={{ display: "flex", flexDirection: 'column', gap: '10px' }}>
                            {[8, 9, 10]?.includes(form?.visa_form?.id_visa_type) ?
                                <>
                                    {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 2)?.map((item: any, index: number) => {
                                        return (
                                            <UploadFile files={files} setFiles={setFiles} item={item} />
                                        )
                                    })}
                                </> : form?.visa_form?.id_visa_type === 18 ?
                                    <>
                                        <StateComponents
                                            otherProps={{ spacing: 2 }}
                                            typeProps={[
                                                {
                                                    seq: 1,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                    },
                                                    fieldProps: {
                                                        heading: t("สถานที่สอบ"),
                                                        required: true,
                                                        value: formAccepting?.visa_examination_name || '',
                                                        onChange: (e) => {
                                                            setFormAccepting({ ...formAccepting, visa_examination_name: e.target.value })
                                                        },
                                                    }
                                                },

                                                {
                                                    seq: 2,
                                                    type: "DATE",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    },
                                                    fieldProps: {
                                                        onChange: (e) => {
                                                            setFormAccepting({ ...formAccepting, visa_examination_start_date: moment(e).format('YYYY-MM-DD') })
                                                        },
                                                        heading: 'วันที่เริ่มต้น',
                                                        placeholder: 'วันที่เริ่มต้น',
                                                        allowClear: true,
                                                        onClear: () => {
                                                            setFormAccepting({ ...formAccepting, visa_examination_start_date: '' })
                                                        },
                                                        value: formAccepting?.visa_examination_start_date,
                                                    },
                                                },
                                                {
                                                    seq: 4,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    },
                                                    fieldProps: {
                                                        heading: "เวลาเริ่มต้น",
                                                        onChange: (e) => {
                                                            setFormAccepting({ ...formAccepting, visa_examination_start_time: e.target.value })
                                                        },
                                                        value: formAccepting?.visa_examination_start_time,
                                                        type: 'time',
                                                    }
                                                },
                                                {
                                                    seq: 3,
                                                    type: "DATE",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    },
                                                    fieldProps: {
                                                        onChange: (e) => {
                                                            setFormAccepting({ ...formAccepting, visa_examination_end_date: moment(e).format('YYYY-MM-DD') })
                                                        },
                                                        heading: 'วันที่สิ้นสุด',
                                                        placeholder: 'วันที่สิ้นสุด',
                                                        allowClear: true,
                                                        onClear: () => {
                                                            setFormAccepting({ ...formAccepting, visa_examination_end_date: '' })
                                                        },
                                                        value: formAccepting?.visa_examination_end_date,
                                                    },
                                                },
                                                {
                                                    seq: 5,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    },
                                                    fieldProps: {
                                                        heading: "เวลาสิ้นสุด",
                                                        onChange: (e) => {
                                                            setFormAccepting({ ...formAccepting, visa_examination_end_time: e.target.value })
                                                        },
                                                        value: formAccepting?.visa_examination_end_time,
                                                        type: 'time',
                                                    }
                                                },

                                            ]} />
                                        <UploadFile files={files} setFiles={setFiles} item={{
                                            document_name: 'ไฟล์แนบ',
                                            id_visa_form_document: 1
                                        }} />

                                    </>
                                    :
                                    <>
                                        {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 2)?.map((item: any, index: number) => {
                                            return (
                                                <div key={index}>
                                                    <Typography>{item?.document_name}{item?.is_req && <span style={{ color: "#FF0000" }}>*</span>}</Typography>
                                                    <Box sx={{
                                                        padding: '10px',
                                                        borderRadius: '8px',
                                                        border: '1px solid #DDE1EB'
                                                    }}>
                                                        <Grid container spacing={2}>
                                                            {files?.filter((x) => x?.id_visa_form_document === item?.id_visa_form_document)?.map((item: any, index: number) => {
                                                                return (
                                                                    <Grid key={index} item xs={12} md={2}>
                                                                        <img src={URL.createObjectURL(item?.file)} style={{
                                                                            width: '100px',
                                                                            height: '100px',
                                                                            objectPosition: 'center',
                                                                            objectFit: 'contain'
                                                                        }} />
                                                                        <Box sx={{ display: 'flex', justifyContent: "space-between" }}>
                                                                            <Typography sx={{
                                                                                width: '70%',
                                                                                fontSize: '12px',
                                                                                display: "-webkit-box",
                                                                                WebkitBoxOrient: "vertical",
                                                                                WebkitLineClamp: "1",
                                                                                overflow: "hidden",
                                                                            }}>{item?.file?.name}</Typography>
                                                                            {!view && <Box sx={{ cursor: 'pointer' }} onClick={() => {

                                                                                setFiles([...files?.filter((x) => x?.id_visa_form_document !== item?.id_visa_form_document), ...files?.filter((x) => x?.id_visa_form_document === item?.id_visa_form_document)?.filter((_, i) => i !== index)])

                                                                            }}>
                                                                                <HighlightOffIcon sx={{ fontSize: '16px' }} />
                                                                            </Box>}
                                                                        </Box>

                                                                    </Grid>
                                                                )
                                                            })}
                                                            <Grid item xs={12} md={2}>
                                                                <img src={AddImage} style={{
                                                                    cursor: 'pointer',
                                                                }} onClick={() => !view && uploadRefs.current[index]?.click()} />
                                                                <input type='file' accept="image/png, image/jpeg" ref={(el) => (uploadRefs.current[index] = el!)} onChange={(e: any) => {
                                                                    if (e.target.files[0]) {
                                                                        setFiles([...files, { ...item, file: e.target.files[0] }])
                                                                        if (uploadRefs.current[index]) {
                                                                            uploadRefs.current[index].value = "";
                                                                        }
                                                                    }
                                                                }} style={{ display: 'none' }} />
                                                            </Grid>
                                                        </Grid>

                                                    </Box>
                                                </div>
                                            )
                                        })}
                                    </>}
                        </div>
                    }
                />
            )}
            {showModal === 3 && (
                <ModalCustom
                    open
                    title={'อนุมัติคำร้อง'}
                    subTitle={t("กรุณาระบุรายละเอียด")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: files?.length === 0,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleSecretariatOfficer() }
                    }}
                    component={
                        <div className='w-full' style={{ display: "flex", flexDirection: 'column', gap: '10px' }}>
                            {[8, 9, 10]?.includes(form?.visa_form?.id_visa_type) ?
                                <>
                                    {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 3)?.map((item: any, index: number) => {
                                        return (
                                            <UploadFile files={files} setFiles={setFiles} item={item} />
                                        )
                                    })}
                                </> :
                                <>
                                    {form?.visa_form?.id_visa_type !== 2 && <InputTextField heading='Reference Number' value={formAccepting?.refer_number} onChange={(e) => {
                                        setFormAccepting({ refer_number: e.target.value })
                                    }} />}
                                    <div style={{ display: "flex", flexDirection: 'column', gap: '10px' }}>

                                        {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 3)?.map((item: any, index: number) => {
                                            return (
                                                <div key={index}>
                                                    <Typography>{item?.document_name}{item?.is_req && <span style={{ color: "#FF0000" }}>*</span>}</Typography>
                                                    <Box sx={{
                                                        padding: '10px',
                                                        borderRadius: '8px',
                                                        border: '1px solid #DDE1EB'
                                                    }}>
                                                        <Grid container spacing={2}>
                                                            {files?.filter((x) => x?.id_visa_form_document === item?.id_visa_form_document)?.map((item: any, index: number) => {
                                                                return (
                                                                    <Grid key={index} item xs={12} md={2}>
                                                                        <img src={URL.createObjectURL(item?.file)} style={{
                                                                            width: '100px',
                                                                            height: '100px',
                                                                            objectPosition: 'center',
                                                                            objectFit: 'contain'
                                                                        }} />
                                                                        <Box sx={{ display: 'flex', justifyContent: "space-between" }}>
                                                                            <Typography sx={{
                                                                                width: '70%',
                                                                                fontSize: '12px',
                                                                                display: "-webkit-box",
                                                                                WebkitBoxOrient: "vertical",
                                                                                WebkitLineClamp: "1",
                                                                                overflow: "hidden",
                                                                            }}>{item?.file?.name}</Typography>
                                                                            {!view && <Box sx={{ cursor: 'pointer' }} onClick={() => {

                                                                                setFiles([...files?.filter((x) => x?.id_visa_form_document !== item?.id_visa_form_document), ...files?.filter((x) => x?.id_visa_form_document === item?.id_visa_form_document)?.filter((_, i) => i !== index)])

                                                                            }}>
                                                                                <HighlightOffIcon sx={{ fontSize: '16px' }} />
                                                                            </Box>}
                                                                        </Box>

                                                                    </Grid>
                                                                )
                                                            })}
                                                            <Grid item xs={12} md={2}>
                                                                <img src={AddImage} style={{
                                                                    cursor: 'pointer',
                                                                }} onClick={() => !view && uploadRefs.current[index]?.click()} />
                                                                <input type='file' accept="image/png, image/jpeg" ref={(el) => (uploadRefs.current[index] = el!)} onChange={(e: any) => {
                                                                    if (e.target.files[0]) {
                                                                        setFiles([...files, { ...item, file: e.target.files[0] }])
                                                                        if (uploadRefs.current[index]) {
                                                                            uploadRefs.current[index].value = "";
                                                                        }
                                                                    }
                                                                }} style={{ display: 'none' }} />
                                                            </Grid>
                                                        </Grid>

                                                    </Box>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </>}
                        </div>
                    }
                />
            )}
            {showModal === 4 && (
                <ModalCustom
                    open
                    title={'อนุมัติคำร้อง'}
                    subTitle={t("กรุณาระบุรายละเอียด")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: files?.length === 0,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleDormitoryStaff() }
                    }}
                    component={
                        <div className='w-full'>

                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            heading: t("Dormitory Name"),
                                            value: formAccepting?.dormitory_name || '',
                                            onChange: (e) => {
                                                setFormAccepting({ ...formAccepting, dormitory_name: e.target.value })
                                            },
                                        }
                                    },

                                    {
                                        seq: 2,
                                        type: "SELECT",
                                        gridProps: {
                                            xs: 12,
                                            md: 4
                                        },
                                        fieldProps: {
                                            labelId: "ss",
                                            heading: "Dormitory Type",
                                            onChange: (e) => {
                                                setFormAccepting({ ...formAccepting, dormitory_type: e.target.value })
                                                // set_id_degree(e.target.value)
                                            },
                                            options: [
                                                {
                                                    label: 'Male',
                                                    value: "Male",
                                                },
                                                {
                                                    label: 'Female',
                                                    value: "Female",
                                                },
                                            ],
                                            selectId: "",
                                            value: formAccepting?.dormitory_type || '',
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 4
                                        },
                                        fieldProps: {
                                            heading: t("Room Number"),
                                            value: formAccepting?.room_number || '',
                                            onChange: (e) => {
                                                setFormAccepting({ ...formAccepting, room_number: e.target.value })
                                            },
                                            onkeypress: handleTypingNumber
                                        }
                                    },
                                    {
                                        seq: 4,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 4
                                        },
                                        fieldProps: {
                                            heading: t("Floor Number"),
                                            value: formAccepting?.floor_number || '',
                                            onChange: (e) => {
                                                setFormAccepting({ ...formAccepting, floor_number: e.target.value })
                                            },
                                            onkeypress: handleTypingNumber
                                        }
                                    },

                                ]} />
                            <div style={{ display: "flex", flexDirection: 'column', gap: '10px', marginTop: '20px' }}>

                                {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 4)?.map((item: any, index: number) => {
                                    return (
                                        <div key={index}>
                                            <Typography>{item?.document_name}{item?.is_req && <span style={{ color: "#FF0000" }}>*</span>}</Typography>
                                            <Box sx={{
                                                padding: '10px',
                                                borderRadius: '8px',
                                                border: '1px solid #DDE1EB'
                                            }}>
                                                <Grid container spacing={2}>
                                                    {files?.filter((x) => x?.id_visa_form_document === item?.id_visa_form_document)?.map((item: any, index: number) => {
                                                        return (
                                                            <Grid key={index} item xs={12} md={2}>
                                                                <img src={URL.createObjectURL(item?.file)} style={{
                                                                    width: '100px',
                                                                    height: '100px',
                                                                    objectPosition: 'center',
                                                                    objectFit: 'contain'
                                                                }} />
                                                                <Box sx={{ display: 'flex', justifyContent: "space-between" }}>
                                                                    <Typography sx={{
                                                                        width: '70%',
                                                                        fontSize: '12px',
                                                                        display: "-webkit-box",
                                                                        WebkitBoxOrient: "vertical",
                                                                        WebkitLineClamp: "1",
                                                                        overflow: "hidden",
                                                                    }}>{item?.file?.name}</Typography>
                                                                    {!view && <Box sx={{ cursor: 'pointer' }} onClick={() => {

                                                                        setFiles([...files?.filter((x) => x?.id_visa_form_document !== item?.id_visa_form_document), ...files?.filter((x) => x?.id_visa_form_document === item?.id_visa_form_document)?.filter((_, i) => i !== index)])

                                                                    }}>
                                                                        <HighlightOffIcon sx={{ fontSize: '16px' }} />
                                                                    </Box>}
                                                                </Box>

                                                            </Grid>
                                                        )
                                                    })}
                                                    <Grid item xs={12} md={2}>
                                                        <img src={AddImage} style={{
                                                            cursor: 'pointer',
                                                        }} onClick={() => !view && uploadRefs.current[index]?.click()} />
                                                        <input type='file' accept="image/png, image/jpeg" ref={(el) => (uploadRefs.current[index] = el!)} onChange={(e: any) => {
                                                            if (e.target.files[0]) {
                                                                setFiles([...files, { ...item, file: e.target.files[0] }])
                                                                if (uploadRefs.current[index]) {
                                                                    uploadRefs.current[index].value = "";
                                                                }
                                                            }
                                                        }} style={{ display: 'none' }} />
                                                    </Grid>
                                                </Grid>

                                            </Box>
                                        </div>
                                    )
                                })}
                            </div>
                            {/* <Typography sx={{ marginTop: '20px' }}>{form?.visa_form_document?.find((x: any) => x?.id_visa_step === 4)?.document_name}{form?.visa_form_document?.find((x: any) => x?.id_visa_step === 4)?.is_req && <span style={{ color: "#FF0000" }}>*</span>}</Typography>
                            <Box sx={{
                                padding: '10px',
                                borderRadius: '8px',
                                border: '1px solid #DDE1EB'
                            }}>
                                <Grid container spacing={2}>
                                    {files?.map((item: any, index: number) => {
                                        return (
                                            <Grid key={index} item xs={12} md={2}>
                                                <img src={item?.id_visa_form_file ? `${pathUrl?.REACT_APP_BASE_API_PUBLIC}/${item?.file_path}${item?.file_name}` : URL.createObjectURL(item)} style={{
                                                    width: '100px',
                                                    height: '100px',
                                                    objectPosition: 'center',
                                                    objectFit: 'contain'
                                                }} />
                                                <Box sx={{ display: 'flex', justifyContent: "space-between" }}>
                                                    <Typography sx={{
                                                        width: '70%',
                                                        fontSize: '12px',
                                                        display: "-webkit-box",
                                                        WebkitBoxOrient: "vertical",
                                                        WebkitLineClamp: "1",
                                                        overflow: "hidden",
                                                    }}>{item?.name || item?.file_name}</Typography>
                                                    {!view && <Box sx={{ cursor: 'pointer' }} onClick={() => {
                                                        if (item?.id_visa_form_file) {
                                                            setFilesRemove([...filesRemove, item])
                                                        }
                                                        setFiles(files?.filter((_, i) => i !== index))

                                                    }}>
                                                        <HighlightOffIcon sx={{ fontSize: '16px' }} />
                                                    </Box>}
                                                </Box>

                                            </Grid>
                                        )
                                    })}
                                    <Grid item xs={12} md={2}>
                                        <img src={AddImage} style={{
                                            cursor: 'pointer',
                                        }} onClick={() => !view && uploadRefs.current?.click()} />
                                        <input type='file' accept="image/png, image/jpeg" ref={uploadRefs} onChange={(e: any) => {
                                            if (e.target.files[0]) {
                                                setFiles([...files, e.target.files[0]])
                                            }
                                        }} style={{ display: 'none' }} />
                                    </Grid>
                                </Grid>

                            </Box> */}

                        </div>
                    }
                />
            )}
            {showModal === 5 && (
                <ModalCustom
                    open
                    title={'อนุมัติคำร้อง'}
                    subTitle={t("กรุณาระบุรายละเอียด")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: files?.length === 0,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleDivisionOfAffairsOfficer() }
                    }}
                    component={
                        <div className='w-full'>
                            <div style={{ display: "flex", flexDirection: 'column', gap: '10px', }}>

                                {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 5)?.map((item: any, index: number) => {
                                    return (
                                        <div key={index}>
                                            <Typography>{item?.document_name}{item?.is_req && <span style={{ color: "#FF0000" }}>*</span>}</Typography>
                                            <Box sx={{
                                                padding: '10px',
                                                borderRadius: '8px',
                                                border: '1px solid #DDE1EB'
                                            }}>
                                                <Grid container spacing={2}>
                                                    {files?.filter((x) => x?.id_visa_form_document === item?.id_visa_form_document)?.map((item: any, index: number) => {
                                                        return (
                                                            <Grid key={index} item xs={12} md={2}>
                                                                <img src={URL.createObjectURL(item?.file)} style={{
                                                                    width: '100px',
                                                                    height: '100px',
                                                                    objectPosition: 'center',
                                                                    objectFit: 'contain'
                                                                }} />
                                                                <Box sx={{ display: 'flex', justifyContent: "space-between" }}>
                                                                    <Typography sx={{
                                                                        width: '70%',
                                                                        fontSize: '12px',
                                                                        display: "-webkit-box",
                                                                        WebkitBoxOrient: "vertical",
                                                                        WebkitLineClamp: "1",
                                                                        overflow: "hidden",
                                                                    }}>{item?.file?.name}</Typography>
                                                                    {!view && <Box sx={{ cursor: 'pointer' }} onClick={() => {

                                                                        setFiles([...files?.filter((x) => x?.id_visa_form_document !== item?.id_visa_form_document), ...files?.filter((x) => x?.id_visa_form_document === item?.id_visa_form_document)?.filter((_, i) => i !== index)])

                                                                    }}>
                                                                        <HighlightOffIcon sx={{ fontSize: '16px' }} />
                                                                    </Box>}
                                                                </Box>

                                                            </Grid>
                                                        )
                                                    })}
                                                    <Grid item xs={12} md={2}>
                                                        <img src={AddImage} style={{
                                                            cursor: 'pointer',
                                                        }} onClick={() => !view && uploadRefs.current[index]?.click()} />
                                                        <input type='file' accept="image/png, image/jpeg" ref={(el) => (uploadRefs.current[index] = el!)} onChange={(e: any) => {
                                                            if (e.target.files[0]) {
                                                                setFiles([...files, { ...item, file: e.target.files[0] }])
                                                                if (uploadRefs.current[index]) {
                                                                    uploadRefs.current[index].value = "";
                                                                }
                                                            }
                                                        }} style={{ display: 'none' }} />
                                                    </Grid>
                                                </Grid>

                                            </Box>
                                        </div>
                                    )
                                })}
                            </div>

                            {/* <Typography sx={{ marginTop: '20px' }}>{form?.visa_form_document?.find((x: any) => x?.id_visa_step === 5)?.document_name}{form?.visa_form_document?.find((x: any) => x?.id_visa_step === 5)?.is_req && <span style={{ color: "#FF0000" }}>*</span>}</Typography>
                            <Box sx={{
                                padding: '10px',
                                borderRadius: '8px',
                                border: '1px solid #DDE1EB'
                            }}>
                                <Grid container spacing={2}>
                                    {files?.map((item: any, index: number) => {
                                        return (
                                            <Grid key={index} item xs={12} md={2}>
                                                <img src={item?.id_visa_form_file ? `${pathUrl?.REACT_APP_BASE_API_PUBLIC}/${item?.file_path}${item?.file_name}` : URL.createObjectURL(item)} style={{
                                                    width: '100px',
                                                    height: '100px',
                                                    objectPosition: 'center',
                                                    objectFit: 'contain'
                                                }} />
                                                <Box sx={{ display: 'flex', justifyContent: "space-between" }}>
                                                    <Typography sx={{
                                                        width: '70%',
                                                        fontSize: '12px',
                                                        display: "-webkit-box",
                                                        WebkitBoxOrient: "vertical",
                                                        WebkitLineClamp: "1",
                                                        overflow: "hidden",
                                                    }}>{item?.name || item?.file_name}</Typography>
                                                    {!view && <Box sx={{ cursor: 'pointer' }} onClick={() => {
                                                        if (item?.id_visa_form_file) {
                                                            setFilesRemove([...filesRemove, item])
                                                        }
                                                        setFiles(files?.filter((_, i) => i !== index))

                                                    }}>
                                                        <HighlightOffIcon sx={{ fontSize: '16px' }} />
                                                    </Box>}
                                                </Box>

                                            </Grid>
                                        )
                                    })}
                                    <Grid item xs={12} md={2}>
                                        <img src={AddImage} style={{
                                            cursor: 'pointer',
                                        }} onClick={() => !view && uploadRefs.current?.click()} />
                                        <input type='file' accept="image/png, image/jpeg" ref={uploadRefs} onChange={(e: any) => {
                                            if (e.target.files[0]) {
                                                setFiles([...files, e.target.files[0]])
                                            }
                                        }} style={{ display: 'none' }} />
                                    </Grid>
                                </Grid>

                            </Box> */}

                        </div>
                    }
                />
            )}
            {showModal === 6 && (
                <ModalCustom
                    open
                    title={'อนุมัติคำร้อง'}
                    subTitle={t("กรุณาระบุรายละเอียด")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: files?.length === 0,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleForeignAffairsDivisionOfficer() }
                    }}
                    component={
                        <div className='w-full'>

                            <div style={{ display: "flex", flexDirection: 'column', gap: '10px', marginTop: '20px' }}>

                                {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 6)?.map((item: any, index: number) => {
                                    return (
                                        <div key={index}>
                                            <Typography>{item?.document_name}{item?.is_req && <span style={{ color: "#FF0000" }}>*</span>}</Typography>
                                            <Box sx={{
                                                padding: '10px',
                                                borderRadius: '8px',
                                                border: '1px solid #DDE1EB'
                                            }}>
                                                <Grid container spacing={2}>
                                                    {files?.filter((x) => x?.id_visa_form_document === item?.id_visa_form_document)?.map((item: any, index: number) => {
                                                        return (
                                                            <Grid key={index} item xs={12} md={2}>
                                                                <img src={URL.createObjectURL(item?.file)} style={{
                                                                    width: '100px',
                                                                    height: '100px',
                                                                    objectPosition: 'center',
                                                                    objectFit: 'contain'
                                                                }} />
                                                                <Box sx={{ display: 'flex', justifyContent: "space-between" }}>
                                                                    <Typography sx={{
                                                                        width: '70%',
                                                                        fontSize: '12px',
                                                                        display: "-webkit-box",
                                                                        WebkitBoxOrient: "vertical",
                                                                        WebkitLineClamp: "1",
                                                                        overflow: "hidden",
                                                                    }}>{item?.file?.name}</Typography>
                                                                    {!view && <Box sx={{ cursor: 'pointer' }} onClick={() => {

                                                                        setFiles([...files?.filter((x) => x?.id_visa_form_document !== item?.id_visa_form_document), ...files?.filter((x) => x?.id_visa_form_document === item?.id_visa_form_document)?.filter((_, i) => i !== index)])

                                                                    }}>
                                                                        <HighlightOffIcon sx={{ fontSize: '16px' }} />
                                                                    </Box>}
                                                                </Box>

                                                            </Grid>
                                                        )
                                                    })}
                                                    <Grid item xs={12} md={2}>
                                                        <img src={AddImage} style={{
                                                            cursor: 'pointer',
                                                        }} onClick={() => !view && uploadRefs.current[index]?.click()} />
                                                        <input type='file' accept="image/png, image/jpeg" ref={(el) => (uploadRefs.current[index] = el!)} onChange={(e: any) => {
                                                            if (e.target.files[0]) {
                                                                setFiles([...files, { ...item, file: e.target.files[0] }])
                                                                if (uploadRefs.current[index]) {
                                                                    uploadRefs.current[index].value = "";
                                                                }
                                                            }
                                                        }} style={{ display: 'none' }} />
                                                    </Grid>
                                                </Grid>

                                            </Box>
                                        </div>
                                    )
                                })}
                            </div>
                            {/* <Typography sx={{ marginTop: '20px' }}>{form?.visa_form_document?.find((x: any) => x?.id_visa_step === 6)?.document_name}{form?.visa_form_document?.find((x: any) => x?.id_visa_step === 6)?.is_req && <span style={{ color: "#FF0000" }}>*</span>}</Typography>
                            <Box sx={{
                                padding: '10px',
                                borderRadius: '8px',
                                border: '1px solid #DDE1EB'
                            }}>
                                <Grid container spacing={2}>
                                    {files?.map((item: any, index: number) => {
                                        return (
                                            <Grid key={index} item xs={12} md={2}>
                                                <img src={item?.id_visa_form_file ? `${pathUrl?.REACT_APP_BASE_API_PUBLIC}/${item?.file_path}${item?.file_name}` : URL.createObjectURL(item)} style={{
                                                    width: '100px',
                                                    height: '100px',
                                                    objectPosition: 'center',
                                                    objectFit: 'contain'
                                                }} />
                                                <Box sx={{ display: 'flex', justifyContent: "space-between" }}>
                                                    <Typography sx={{
                                                        width: '70%',
                                                        fontSize: '12px',
                                                        display: "-webkit-box",
                                                        WebkitBoxOrient: "vertical",
                                                        WebkitLineClamp: "1",
                                                        overflow: "hidden",
                                                    }}>{item?.name || item?.file_name}</Typography>
                                                    {!view && <Box sx={{ cursor: 'pointer' }} onClick={() => {
                                                        if (item?.id_visa_form_file) {
                                                            setFilesRemove([...filesRemove, item])
                                                        }
                                                        setFiles(files?.filter((_, i) => i !== index))

                                                    }}>
                                                        <HighlightOffIcon sx={{ fontSize: '16px' }} />
                                                    </Box>}
                                                </Box>

                                            </Grid>
                                        )
                                    })}
                                    <Grid item xs={12} md={2}>
                                        <img src={AddImage} style={{
                                            cursor: 'pointer',
                                        }} onClick={() => !view && uploadRefs.current?.click()} />
                                        <input type='file' accept="image/png, image/jpeg" ref={uploadRefs} onChange={(e: any) => {
                                            if (e.target.files[0]) {
                                                setFiles([...files, e.target.files[0]])
                                            }
                                        }} style={{ display: 'none' }} />
                                    </Grid>
                                </Grid>

                            </Box> */}

                        </div>
                    }
                />
            )}
            {showModal === 98 && (
                <ModalCustom
                    open
                    title={'ปฏิเสธคำร้อง'}
                    subTitle={t("กรุณาระบุหมายเหตุ")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !formAccepting?.remark,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleReject() }
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            heading: t("หมายเหตุ"),
                                            value: formAccepting?.remark || '',
                                            onChange: (e) => {
                                                setFormAccepting({ ...formAccepting, remark: e.target.value })
                                            },
                                            minRow: 8,
                                            multiline: true,
                                            inputHeight: "auto"
                                        }
                                    },



                                ]} />
                        </div>
                    }
                />
            )}
            {showModal === 99 && (
                <ModalCustom
                    open
                    title={'ส่งทบทวน'}
                    subTitle={t("กรุณาระบุหมายเหตุ")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !formAccepting?.remark,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleReview() }
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            heading: t("หมายเหตุ"),
                                            value: formAccepting?.remark || '',
                                            onChange: (e) => {
                                                setFormAccepting({ ...formAccepting, remark: e.target.value })
                                            },
                                            minRow: 8,
                                            multiline: true,
                                            inputHeight: "auto"
                                        }
                                    },



                                ]} />
                        </div>
                    }
                />
            )}
            {showModal === 8 && (
                <ModalCustom
                    open
                    title={'อนุมัติคำร้อง'}
                    subTitle={t("กรุณาระบุหมายเหตุ")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !formAccepting?.remark,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleTeacher() }
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            heading: t("หมายเหตุ"),
                                            value: formAccepting?.remark || '',
                                            onChange: (e) => {
                                                setFormAccepting({ ...formAccepting, remark: e.target.value })
                                            },
                                            minRow: 8,
                                            multiline: true,
                                            inputHeight: "auto"
                                        }
                                    },



                                ]} />
                        </div>
                    }
                />
            )}
            {showModal === 7 && (
                <ModalCustom
                    open
                    title={'ดำเนินการปรับสถานะลาออก'}
                    subTitle={t("กรุณาระบุหมายเหตุ")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !formAccepting?.remark,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleRegistrar() }
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                sxContainer={{ marginBottom: '20px' }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            heading: t("หมายเหตุ"),
                                            value: formAccepting?.remark || '',
                                            onChange: (e) => {
                                                setFormAccepting({ ...formAccepting, remark: e.target.value })
                                            },
                                            minRow: 8,
                                            multiline: true,
                                            inputHeight: "auto"
                                        }
                                    },



                                ]} />
                            {form?.visa_form_document?.filter((x: any) => x?.id_visa_step === 7)?.map((item: any, index: number) => {
                                return (
                                    <UploadFile files={files} setFiles={setFiles} item={item} />
                                )
                            })}
                        </div>
                    }
                />
            )}
            {showModalGuestion !== '' && (
                <ModalCustom
                    open
                    title={'ประเมินความพึ่งพอใจ'}
                    // subTitle={t("Guideline for Requesting a Certification of Student")}
                    onClose={() => setShowModalGuestion('')}

                    containerButton={{
                        onClose: () => setShowModalGuestion(''),
                        hidden_submit: visaSatisfactionDetail,
                        // onSubmit: () => {
                        //     handleQuestion()
                        // }
                    }}
                    component={
                        <div className='w-full'>
                            <Box sx={{ width: "100%", display: 'flex', }}>
                                <Box style={{ width: "50%" }}></Box>
                                <Box
                                    style={{
                                        width: "50%",
                                        display: 'flex',
                                        justifyContent: "space-around",
                                    }}
                                >

                                    {['น้อยมาก', 'น้อย', 'ปานกลาง', 'ดี', 'ดีมาก'].map((num, i) => (
                                        <Typography key={i} sx={{ width: '100px', textAlign: 'center' }}>{num}</Typography>
                                    ))}
                                </Box>
                            </Box>
                            {visaSatisfaction?.map((item: any, i: number) => {
                                return (
                                    <Box
                                        key={i}
                                        sx={{
                                            width: "100%",
                                            display: 'flex',
                                            borderBottomWidth: 1,
                                            borderBottomColor: "#e7e7e7",
                                            paddingVertical: 5,
                                        }}
                                    >
                                        <Box sx={{ width: "50%", display: "flex", alignItems: 'end' }}>
                                            <Typography>{i + 1}. {item?.visa_satisfaction_question_name}</Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                width: "50%",
                                                display: 'flex',
                                                justifyContent: "space-around",
                                            }}
                                        >
                                            {[1, 2, 3, 4, 5].map((num) => (
                                                <Radio
                                                    key={num}
                                                    value={num}
                                                    disabled={visaSatisfactionDetail}
                                                    checked={item?.point == num ? true : false}
                                                    onChange={(e) => {
                                                        setVisaSatisfaction((prevData) =>
                                                            prevData.map((p) =>
                                                                p.id_visa_satisfaction_question === item?.id_visa_satisfaction_question
                                                                    ? {
                                                                        ...p,
                                                                        point: e.target.value,
                                                                    }
                                                                    : p
                                                            )
                                                        );
                                                    }}
                                                />
                                            ))}
                                        </Box>
                                    </Box>

                                )
                            })}
                            <Box sx={{ marginTop: '20px' }}>
                                <InputTextField disabled={visaSatisfactionDetail} heading='รายละเอียดเพิ่มเติม' value={remark} onchange={(e) => setRemark(e.target.value)} multiline minRow={3} inputHeight={'auto'} />
                            </Box>

                        </div>
                    }
                />
            )}

        </div >
    )
}
const UploadFile = (props: any) => {
    const { files, setFiles, item } = props
    const fileRef = useRef<any>()

    const onImageChange = async (event: any) => {
        if (event.target.files && event.target.files[0]) {
            setFiles([...files, { ...item, file: event.target.files[0] }])
            // console.log(files);
            // setFiles(files?.map((q: any) => {
            //     console.log(q, 'llll');
            //     return item?.id_visa_form_document === q?.id_visa_form_document
            //         ? {
            //             ...q,
            //             file: event.target.files[0]
            //         }
            //         : q

            // }
            // ))

            if (fileRef.current) {
                fileRef.current.value = "";
            }
        }
    }
    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }


    return (
        <Box sx={{
            padding: '10px 15px', border: '1px solid #DDE1EB',
            borderRadius: '8px',
            display: "flex",
            flexDirection: 'column'
        }}>
            <Box sx={{ width: "100%" }}>
                <Box sx={{ display: "flex", gap: "10px", alignItems: "center", }}>

                    <AddBoxIcon sx={{ color: '#5FB95D', cursor: "pointer" }} onClick={() => fileRef.current.click()} />
                    <Typography sx={{
                        // whiteSpace: "nowrap", 
                        width: '100%', overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: "1",
                    }}>{item?.document_name}<span style={{ color: "red", marginLeft: '10px' }}>{item?.is_req ? '*' : ''}</span></Typography>
                </Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", }}>
                {files.filter((x: any) => x?.id_visa_form_document === item?.id_visa_form_document)?.filter((x: any) => x?.file)?.map((x: any) => {
                    return (
                        <Box sx={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: 'space-between' }}>
                            <Typography sx={{
                                width: '100%', overflow: "hidden",
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: "1",
                            }}>{x?.file?.name || x?.file_name} {formatBytes(x?.file?.size || x?.file_size)}</Typography>
                            <OptionsButtonCustom
                                // enableEdit
                                enableView
                                enableDelete
                                onViewClick={() => { window.open(URL.createObjectURL(x?.file), '_blank') }}
                                // onEditClick={() => navigate(routeName.admission.SetupCourseOpeningDetail)}
                                onDeleteClick={() => {
                                    setFiles((prevData: any) => {
                                        return prevData.filter((q: any) =>
                                            x?.id_visa_form_document !== q?.id_visa_form_document
                                        )
                                    })

                                }}
                            />
                        </Box>
                    )
                })}


            </Box>


            <input ref={fileRef} className='hidden' type='file'
                accept={"image/*"}
                onChange={(e: any) => onImageChange(e)} />
        </Box>
    )
}